import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseGridFormComponent } from './base-grid-form/base-grid-form.component';
import { RteMaterialModule, RteLibraryModule } from 'rte-library';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseFormComponent } from './base-form/base-form.component';
import { InputBaseFormComponent } from './base-form/input-form/input-form.component';
import { AngularMaterialBaseModule } from 'src/app/modules/angular-material-base.module';
import { TextMaskModule } from 'angular2-text-mask';
import { DatePickerWithMaskDirective } from './directives/date-picker-with-mask.directive';
import { IconFormComponent } from './base-form/icon-form/icon-form.component';
import { MatAutocompleteModule, MatProgressBarModule } from '@angular/material';

@NgModule({
  declarations: [
    BaseGridFormComponent,
    BaseFormComponent,
    InputBaseFormComponent,
    DatePickerWithMaskDirective,
    IconFormComponent,
  ],
  exports: [
    BaseGridFormComponent,
    BaseFormComponent,
    InputBaseFormComponent,
    DatePickerWithMaskDirective
  ],
  imports: [
    CommonModule,
    RteMaterialModule,
    RteLibraryModule,
    AngularMaterialBaseModule,
    TextMaskModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class RteFormModule { }
